import styled, { css } from 'styled-components';
import Button from '@mlb/react-patterns/v4/components/Button/button';
import { ButtonShapes } from '@mlb/react-patterns/v4/components/Button/button.types';
import { TicketButton, TicketWrapper } from '../Preview/Preview.style';
import {
    PlayerHeaderWrapper,
    PlayerListWrapper,
    PlayerNameWrapper,
    PlayerStatsWrapper,
    PlayerWrapper,
    TitleWrapper,
    TopPerformersWrapper as TopPerformersContainer
} from '../TopPerformers/TopPerformers.style';
import {
    PlayerDecisionsWrapper,
    SavePlaceHolder
} from '../Decisions/Decisions.style';
import {
    PlayerDataWrapper,
    PlayerMatchupWrapper,
    PlayerNameWrapper as PitcherNameWrapper,
    PlayerDecisionWrapper,
    PlayerStatsWrapper as DecisionStatsWrapper
} from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup.style';
import {
    ImageWrapper,
    Img
} from '@mlb/react-patterns/v4/components/Image/image.style';
import { GAME_CONTEXT_BREAKPOINTS } from '../themes/breakpoints';

const { MD_MIN, MOBILE, DESKTOP } = GAME_CONTEXT_BREAKPOINTS;

export const GameContextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-family: var(--gameday-primary-font);
    background: var(--gameday-game-context-background-color);
    max-width: ${({ $useFullViewport }) =>
        $useFullViewport ? '100%' : '1056px'};
    box-sizing: content-box;
    padding-top: 16px;
    gap: 16px;
    @media (min-width: ${DESKTOP}) {
        gap: 24px;
        padding-top: 24px;
    }
    ${({ $useFullViewport }) => {
        if ($useFullViewport) {
            return css`
                position: fixed;
                bottom: 0;
                width: 100%;
            `;
        }
    }}
`;

export const DetailsLayoutContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: 16px;
    @media (min-width: ${MD_MIN}) {
        grid-auto-flow: column;
        grid-auto-columns: 2fr 3fr;
        gap: 12px;
    }
    @media (min-width: ${DESKTOP}) {
        gap: 16px;
    }
`;

export const MatchupLayout = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    border-right: none;
    border-bottom: 1px solid var(--gameday-game-context-divider-color);
    padding: 0 0 16px 0;
    box-sizing: content-box;
    @media (min-width: ${MD_MIN}) {
        border-right: 1px solid var(--gameday-game-context-divider-color);
        border-bottom: none;
        padding: 0 12px 0 0;
        box-sizing: border-box;
    }
    @media (min-width: ${DESKTOP}) {
        padding: 0 16px 0 0;
        gap: 24px;
    }
`;

export const Team = styled.div`
    display: flex;
    align-items:  ${({ displayExtraInfo }) => displayExtraInfo ? 'flex-start' : 'center'};
    justify-content: space-between;
    gap: 8px;
`;

export const TeamScore = styled.div`
    color: var(--gameday-game-context-primary-text-color);
    font-weight: 700;
    font-size: 23px;
    line-height: 23px;
    @media (min-width: ${DESKTOP}) {
        font-size: 28px;
        line-height: 28px;

    }
`;

export const TeamRecord = styled.div`
    color: var(--gameday-game-context-secondary-text-color);
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    @media (min-width: ${DESKTOP}) {
        font-size: 19px;
    }
`;

export const TeamNameDisplay = styled.div`
    font-size: 23px;
    line-height: 23px;
    gap: 8px;
    font-style: normal;
    font-weight: 700;
    display: flex;
    align-items: center;
    color: var(--gameday-game-context-primary-text-color);
    @media (min-width: ${DESKTOP}) {
        font-size: 28px;
        line-height: 28px;
    }
    ${ImageWrapper} {
        flex-shrink: 0;
        line-height: 0;
        @media (max-width: ${MOBILE}) {
            width: 32px;
        }
        ${Img} {
            max-width: 100%;
        }
    }
`;

export const TeamName = styled.div`
    max-width: 80%;
    >div:first-child {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
`;
export const GameTimeLayer = styled.div`
    display: flex;
    justify-content: space-between;
    span {
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 19px;
        color: var(--gameday-game-context-primary-text-color);
        @media (min-width: ${DESKTOP}) {
            font-size: 19px;
        }
    }
`;

export const GameDetailsLayout = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
`;

export const GameActionsLayout = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
    border-top: 1px solid var(--gameday-game-context-divider-color);
    padding-top: 16px;
    ${PlayerDecisionsWrapper} {
        padding: 4px 0;
        justify-content: space-evenly;
        ${PlayerMatchupWrapper} {
            margin: 0;
            > div:last-child > div:first-child > div {
                border-bottom: none;
                color: var(--gameday-game-context-primary-text-color);
            }
        }
        ${PitcherNameWrapper}, ${PlayerDecisionWrapper} {
            margin-bottom: 4px;
            font-size: 12px;
            @media (min-width: ${DESKTOP}) {
                font-size: 14px;
            }
        }
        ${PlayerDecisionWrapper}, ${DecisionStatsWrapper} {
            color: var(--gameday-game-context-secondary-text-color);
            font-size: 12px;
            line-height: 12px;
            @media (min-width: ${DESKTOP}) {
                font-size: 14px;
                line-height: 14px;
            }
        }
        ${PlayerDataWrapper} {
            line-height: 100%;
            display: flex;
            flex-direction: column;
            margin-left: 0;
        }
        ${SavePlaceHolder} {
            display: none;
        }
    }
`;

export const GameActionDetailsContainer = styled.div`
    margin: auto;
    display: flex;
    align-items: center;
    gap: 24px;
`;

export const BroadcastLabel = styled.div`
    font-size: 12px;
    line-height: 12px;
    color: var(--gameday-game-context-primary-text-color);
    @media (min-width: ${DESKTOP}) {
        font-size: 19px;
        line-height: 19px;
    }
`;
export const ProductButtonsContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 6px;
    @media (min-width: ${MD_MIN}) {
        gap: 16px;
    }
    ${TicketWrapper} {
        margin-top: 0px;
        max-width: 167px;
        width: 100%;
        @media (min-width: ${DESKTOP}) {
            max-width: 252px;
        }
    }
    ${TicketButton} {
        height: 32px;
        border-radius: 100px;
        border: 2px solid var(--gameday-ticket-button-color) !important;
        font-size: 14px;
        line-height: 14px;
        padding: 6px 16px;
        color: var(--gameday-ticket-button-color) !important;
        font-weight: 700;
        margin-top: 0px;
        background-color: transparent !important;
        width: 100%;
        @media (min-width: ${DESKTOP}) {
            font-size: 16px;
            line-height: 100%;
            padding: 8px 16px;
            height: 48px;
        }
        &:hover {
            border-width: 3px !important;
        }
    }
`;

export const ProductButtonWrapper = styled.div`
    max-width: 167px;
    width: 100%;
    @media (min-width: ${DESKTOP}) {
        max-width: 252px;
    }
`;

export const ProductButton = styled(Button).attrs((props) => ({
    shape: ButtonShapes.PILL,
    additionalProps: {
        as: 'a',
        role: undefined,
        type: undefined,
        'aria-pressed': undefined,
        color: undefined,
        shape: undefined,
        target: '_blank',
        href: props.url || ''
    }
}))`
    height: 32px;
    width: 100%;
    border-radius: 100px;
    border: 2px solid var(--gameday-game-context-button-color);
    font-size: 14px;
    color: var(--gameday-game-context-button-color) !important;
    font-weight: 700;
    line-height: 14px;
    padding: 6px 16px;
    background-color: transparent !important;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    text-decoration: none;
    @media (min-width: ${DESKTOP}) {
        font-size: 16px;
        line-height: 100%;
        padding: 8px 16px;
        height: 48px;
    }
    &:hover {
        border-width: 3px;
    }
`;

export const TopPerformersWrapper = styled.div`
    ${TopPerformersContainer} {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    ${TitleWrapper} {
        font-size: 16px;
        line-height: 16px;
        font-weight: 700;
        margin-bottom: 0px;
        @media (min-width: ${DESKTOP}) {
            font-size: 19px;
            line-height: 19px;
        }
    }
    ${PlayerListWrapper} {
        gap: 8px;
    }
    ${PlayerHeaderWrapper} {
        line-height: 12px;
        padding-top: 4px;
        @media (min-width: ${DESKTOP}) {
            line-height: 14px;
        }
    }
    ${PlayerNameWrapper} {
        /* font-family: "Proxima Nova"; */
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
        letter-spacing: 0.24px;
        color: var(--gameday-game-context-primary-text-color) !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
        @media (min-width: ${DESKTOP}) {
            font-size: 14px;
            letter-spacing: 0.28px;
        }
    }
    ${PlayerWrapper} {
        border: none !important;
        padding-top: 16px;
        flex: 1 1 0;
        width: 0;

        > div:first-child {
            display: flex;
            justify-content: center;
            margin: 0;
        }

        a {
            display: flex;
            justify-content: center;
        }
    }
    ${PlayerStatsWrapper} {
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        color: var(--gameday-game-context-secondary-text-color);
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        white-space: nowrap;
        width: 100%;

        :not(:last-of-type) {
            ::after {
                padding-right: 2px;
                margin-bottom: 4px;
            }
        }
        @media (min-width: ${DESKTOP}) {
            font-size: 14px;
            line-height: 14px;
        }
    }
`;

const TagLabelBase = styled.div`
    color: var(--gameday-tag-label-text);
    font-size: 12px;
    line-height: 16px;
    height: 16px;
    font-weight: 700;
    text-transform: uppercase;
    padding: 0px 6px;
    border-radius: 8px;
`;
export const TagLabel = styled(TagLabelBase)`
    background-color: var(--gameday-tag-label-background);
`;
export const TagLabelAlert = styled(TagLabelBase)`
    background-color: var(--gameday-alert-red);
`;
